import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNotifier } from "react-headless-notifier";

import { LoadingIcon, NotifierNotification } from "@mwi/ui";

import { RootState } from "store";
import useTitle from "hooks/useTitle";
import { MessagesEvent } from "middlewares/messages";
import {
  clearError,
  getAllConversations,
  getConversation,
} from "slices/messages";

import ConversationsListSection from "./sections/Conversations";
import MessagesSection from "./sections/Messages";

const MessagesPage = () => {
  useTitle("Your Messages");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { conversationId } = useParams();
  const { notify } = useNotifier();

  const { error, messagingBlocked, isConnected } = useSelector(
    (state: RootState) => ({
      error: state.messages.error,
      messagingBlocked: state.practice.messaging_blocked,
      isConnected: state.messages.isConnected,
    }),
  );

  useEffect(() => {
    if (error) {
      notify(
        <NotifierNotification
          type="error"
          title="Error"
          message={error.message}
        />,
      );

      if (
        error.source === MessagesEvent.SendMessage &&
        conversationId &&
        conversationId !== "new"
      ) {
        dispatch(getConversation({ conversationId }));
      }

      if (error.source === MessagesEvent.CreateConversation) {
        dispatch(getAllConversations());
      }

      dispatch(clearError());
    }
  }, [error]);

  if (messagingBlocked === false) {
    return (
      <div className="h-full relative flex flex-col flex-grow tablet:pt-5 tablet:py-5">
        <div className="h-full relative flex flex-col flex-grow tablet:grid tablet:gap-6 tablet:grid-cols-12">
          {!isConnected && (
            <div className="flex flex-col flex-grow items-center justify-center tablet:col-start-1 tablet:col-end-13">
              <LoadingIcon className="w-10 h-10 text-grey" />
            </div>
          )}

          {isConnected && (
            <>
              <ConversationsListSection
                onSelectConversation={(conversationId) =>
                  navigate(`/messages/${conversationId}`)
                }
                selectedConversation={conversationId}
              />
              <MessagesSection
                newConversation={conversationId == "new"}
                conversationId={
                  conversationId == "new" ? undefined : conversationId
                }
              />
            </>
          )}
        </div>
      </div>
    );
  }

  return null;
};

export default MessagesPage;
